import { textV4Variants } from "../../components/TextV4/TextV4";
import { headingTheme } from "../../theme/components";

export const CHAKRA_REACT_SELECT_STYLE: any = {
  option: (provided: any) => ({
    ...provided,
    ...headingTheme?.sizes?.chakra_label_large,
    backgroundColor: 'transparent',
  }),
  singleValue: (provided: any) => ({
    ...provided,
    ...headingTheme?.sizes?.chakra_label_large,
  }),
  placeholder: (provided: any) => ({
    ...provided,
    ...headingTheme?.sizes?.chakra_label_large,
  }),
  menuList: (provided: any) => ({
    ...provided,
    ...headingTheme?.sizes?.chakra_label_large,
    backgroundColor: 'background',
    maxHeight: '200px',
  }),
  menu: (provided: any) => ({
    ...provided,
    zIndex: 999,
  }),
  container: (provided: any) => ({
    ...provided,
    width: '100%'
  }),
  input: (provided: any) => ({
    ...provided,
    ...headingTheme?.sizes?.chakra_label_large,
    color: 'inherit', // or specify a color like 'black'
    backgroundColor: 'transparent',
  }),
}

export const CHAKRA_REACT_SELECT_STYLE_V4: any = {
  container: (provided: any) => ({
    ...provided,
    width: '100%',
  }),

  control: (provided: any, state: any) => ({
    ...provided,
    ...textV4Variants.v4_dekstop_d_headline,
    height: '48px',
    paddingTop: '12px',
    paddingBottom: '12px',
    paddingLeft: '16px',
    paddingRight: '16px',
    borderRadius: '8px',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: state.isFocused
      ? 'var(--chakra-colors-Jarivis-Blue-Border)'
      : 'var(--chakra-colors-jarivis-neutral-50)',
    color: 'var(--chakra-colors-jarivis-neutral-50)',
    backgroundColor: 'transparent',
    transition: 'all 0.2s ease',
    '&:hover': {
      borderColor: state.isFocused
        ? 'var(--chakra-colors-Jarivis-Blue-Border)'
        : 'var(--chakra-colors-jarivis-neutral-50)',
    },
    boxShadow: 'none',
    outline: 'none',
    '&:focus': {
      boxShadow: 'none',
    },
    '&[data-focus]': {
      boxShadow: 'none',
    },
    '&[data-invalid]': {
      boxShadow: 'none',
      borderColor: 'var(--chakra-colors-Jarivis-Danger-Border)',
    },
  }),

  valueContainer: (provided: any) => ({
    ...provided,
    padding: 0,
  }),

  input: (provided: any) => ({
    ...provided,
    ...textV4Variants.v4_dekstop_d_headline,
    color: 'var(--chakra-colors-jarivis-neutral-50)',
    backgroundColor: 'transparent',
    margin: 0,
    padding: 0,
    '&[data-invalid]': {
      color: 'var(--chakra-colors-Jarivis-Danger-Main)',
    },
  }),

  singleValue: (provided: any, state: any) => {
    const isInvalid = state.selectProps['aria-invalid']
    return {
      ...provided,
      ...textV4Variants.v4_dekstop_d_headline,
      color: isInvalid ? 'var(--chakra-colors-Jarivis-Danger-Main)' : 'var(--chakra-colors-jarivis-neutral-50)',
    }
  },

  placeholder: (provided: any, state: any) => {
    const isInvalid = state.selectProps['aria-invalid']
    return {
      ...provided,
      ...textV4Variants.v4_dekstop_d_headline,
      color: isInvalid ? 'var(--chakra-colors-Jarivis-Danger-Main)' : 'var(--chakra-colors-jarivis-neutral-50)',
    }
  },

  menu: (provided: any) => ({
    ...provided,
    zIndex: 999,
  }),

  menuList: (provided: any) => ({
    ...provided,
    backgroundColor: 'var(--chakra-colors-background)',
    paddingTop: '12px',
    paddingBottom: '12px',
    paddingLeft: '16px',
    paddingRight: '16px',
    maxHeight: '166px',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'var(--chakra-colors-jarivis-neutral-50)',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px'
  }),

  option: (provided: any, state: any) => ({
    ...provided,
    ...textV4Variants.v4_dekstop_d_headline,
    backgroundColor: state.isFocused
      ? 'var(--chakra-colors-Jarivis-Blue-Surface)'
      : 'transparent',
    color: 'var(--chakra-colors-jarivis-neutral-50)',
    cursor: 'pointer',
    paddingTop: '6px',
    paddingBottom: '6px',
    paddingLeft: '4px',
    paddingRight: '4px',
    borderRadius: '10px'
  }),
}

export interface ChakraReactSelectValueProps {
  label: string
  value: string
}